import { Button, Combobox } from "@aidkitorg/component-library";
import React, { useState } from "react";
import { useLocalizedStrings } from "../../../Localization";
import { useMyReviews } from "../../../Contexts/MyReviewsContext";

export const MyReviewsFilter: React.FC = () => {
  const L = useLocalizedStrings();
  const { onFiltersChange, availableQueues } = useMyReviews();

  // Local UI state for filter selection
  const [reviewState, setReviewState] = useState<Array<{label: string, value: string}>>([]);
  const [queue, setQueue] = useState<Array<{label: string, value: string}>>([]);

  const applyFilters = () => {
    // Convert UI state to API format
    onFiltersChange({
      queue: queue.map(q => q.value),
      reviewState: reviewState.map(r => r.value)
    });
  }

  const resetFilters = () => {
    setReviewState([]);
    setQueue([]);
    onFiltersChange({
      queue: [],
      reviewState: []
    });
  }

  const REVIEW_STATE_FILTER_OPTIONS = [
    {value: 'in_progress', label: L.admin_panel.reviews.in_review},
    {value: 'complete', label: L.admin_panel.reviews.completed},
    {value: 'N/A', label: 'N/A'}
  ];

  const QUEUE_FILTER_OPTIONS = availableQueues.map(queue => ({
    value: queue,
    label: queue
  }));

  return (
    <div className="w-full">
      <div className="flex flex-wrap gap-4">
        <div>
          <Combobox
            className="h-10"
            by="value"
            label={L.admin_panel.reviews.review_state}
            multiple={true}
            options={REVIEW_STATE_FILTER_OPTIONS}
            value={reviewState}
            onChange={(value) => setReviewState(value)}
          />
        </div>
        <div className="min-w-56">
          <Combobox
            className="h-10"
            by="value"
            label={L.admin_panel.reviews.queue}
            multiple={true}
            options={QUEUE_FILTER_OPTIONS}
            value={queue}
            onChange={(value) => setQueue(value)}
          />
        </div>
      </div>

      <div className="pt-4">
        <div className="flex gap-2">
          <Button onClick={resetFilters} variant="secondary">{L.admin_panel.payments.reset_filters}</Button>
          <Button onClick={applyFilters}>{L.admin_panel.payments.apply_filters}</Button>
        </div>
      </div>
    </div>
  )
}
